import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  useTheme,
  FunctionField,
  RecordContextProvider,
  ChipField,
} from "react-admin";
import factoryDebtPayFilterList from "../../components/factoryDebtPayments/filter/factoryDebtPayFilterList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import AccountPayablePaymentExpandList from "../../components/accountPayablePayments/expand/AccountPayablePaymentExpandList";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountPayablePaymentFooterList from "../../components/accountPayablePayments/footer/AccountPayablePaymentFooterList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountPayablePaymentList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      approved: 1,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.factory_debt_payment"
        empty={false}
        actions={<DownloadAction />}
        filters={factoryDebtPayFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<AccountPayablePaymentFooterList />} />}
          bulkActionButtons={false}
          expand={<AccountPayablePaymentExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField label="mine.label.depo" source="company.alias" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField label="Supplier" source="supplier.name" />
          <FunctionField
            textAlign="center"
            label="mine.label.type"
            render={(record) => {
              let rec = {};
              if (record.type === 1) {
                rec.type = "Transfer";
                rec.color = "primary";
              } else if (record.type === 2) {
                rec.type = "Cash";
                rec.color = "warning";
              }
              return (
                <RecordContextProvider value={rec}>
                  <ChipField source="type" color={rec.color} size="small" />
                </RecordContextProvider>
              );
            }}
          />
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default AccountPayablePaymentList;
